import { consume } from '@lit/context';
import { t } from 'i18next';
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Ref, createRef, ref } from 'lit/directives/ref.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import {
  ConfiguratorContextType,
  GlobalComponentType,
  configuratorGlobal,
  global,
} from '@/context';
import { baseStyles, buttonStyles, typographyStyles } from '@/styles';

import { FgDialog } from '@/components/fg-dialog';

@customElement('fg-quantity-stock-notification-dialog')
export class FgQuantityStockNotificationDialog extends LitElement {
  private fgDialogRef: Ref<FgDialog> = createRef();

  @property({ type: String })
  variantName = '';

  @property({ type: String })
  variantCode = '';

  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  @consume({ context: configuratorGlobal.context, subscribe: true })
  configuratorContext!: ConfiguratorContextType;

  openDialog() {
    this.fgDialogRef.value?.open();
  }

  closeDialog() {
    this.fgDialogRef.value?.close();
  }

  dispatchStockNotificationEvent() {
    this.dispatchEvent(
      new CustomEvent('trigger-stock-notification-mail', {
        composed: true,
        detail: {
          variantCode: this.variantCode,
          variantName: this.variantName,
        },
      }),
    );
    this.closeDialog();
  }

  render() {
    return html`
      <fg-dialog part=${this.globalContext.layout} ${ref(this.fgDialogRef)}>
        <span slot="title">${t('actions.notifyMe')}</span>
        <div class="body">
          ${unsafeHTML(
            t('content.configurator.stock.stockNotification', {
              productName: this.configuratorContext.productName,
              variantName: this.variantName,
            }),
          )}
          <div class="dialog-footer">
            <button class="button button-tertiary" @click=${this.closeDialog}>
              ${t('actions.cancel')}
            </button>
            <button
              class="button button-primary"
              @click=${this.dispatchStockNotificationEvent}
            >
              ${t('actions.notifyMe')}
            </button>
          </div>
        </div>
      </fg-dialog>
    `;
  }

  static styles = [
    baseStyles,
    typographyStyles,
    buttonStyles,
    css`
      .dialog-footer {
        margin-top: 24px;
        display: flex;
        gap: 16px;
      }
      .dialog-footer button {
        width: 50%;
      }
    `,
  ];
}
